module.exports = __webpack_public_path__ + "static/img/poster-bac1.57eba2ce.png";